import { EventEmitter, AfterViewInit, Component, OnInit, ViewChild, Output, Input, inject, PLATFORM_ID } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { isPlatformBrowser } from '@angular/common';

@Component({
  selector: 'app-address-autocomplete',
  templateUrl: './address-autocomplete.component.html',
  styleUrls: ['./address-autocomplete.component.scss'],
  standalone: true,
  imports: [MatFormFieldModule, MatInputModule, TranslateModule]
})
export class AddressAutocompleteComponent implements OnInit, AfterViewInit {

  public adressType: string;

  @Input() set adressTypeSet(address: string) {
    if (address) {
      this.adressType = address;
    }
  }

  @Input() inputText: string;
  @Input() setTextToInput: boolean;
  @Input() injectAddress: string;

  @ViewChild('addresstext') addresstext: any;
  @Output() setAddress: EventEmitter<any> = new EventEmitter();
  public queryWait: boolean;
  public defaultAddress: any;

  private plaformId = inject(PLATFORM_ID);
  private isBrowser = isPlatformBrowser(this.plaformId);

  ngOnInit(): void {
    if (this.setTextToInput === true) {
      if (this.isBrowser) this.defaultAddress = JSON.parse(localStorage.getItem('address') || '{}').displayName ?? '';
    } else {
      if (this.injectAddress) {
        this.defaultAddress = this.injectAddress;
      } else {
        this.defaultAddress = '';
      }
    }
  }

  ngAfterViewInit(): void {
    this.getPlaceAutocomplete();
  }

  public getPlaceAutocomplete(): void {
    const autocomplete = new google.maps.places.Autocomplete(this.addresstext.nativeElement,
      {
        componentRestrictions: { country: 'MX' },
        types: [this.adressType]
      });
    google.maps.event.addListener(autocomplete, 'place_changed', () => {
      const place = autocomplete.getPlace();
      this.invokeEvent(place);
    });
  }

  public onInputKeydown(event: KeyboardEvent): void {
    if (event.key === 'Enter') {
      event.preventDefault();
    }
  }

  public invokeEvent(place: any): void {
    this.setAddress.emit(place);
  }

}
